<template>
	<v-dialog
		v-bind:value="isDisplay"
		v-on:input="onClose"
		max-width="350"
		contentClass="tc-right-pane"
		transition="slide-x-reverse-transition"
		:persistent="isPersistent"
		ref="dialog"
	>
		<div class="v-overlay" :class="classOverlay"></div>
		<slot></slot>
	</v-dialog>
</template>
<script>
import MouseState from '../classes/MouseState';
import MouseStateMachine from '../classes/MouseStateMachine';

export default {
	name: 'RightPane',
	props: [
		"display",
		"persistent",
	],
	data() {
		let state_default = new MouseState({
			down: (e, next) => {
				if(this.persistent)
					return;
				if (!this.$refs.dialog)
					return;
				let content = this.$refs.dialog.$refs.content;
				if (content && content.contains(e.target)) {
					next(state_downed);
				}
			},
		});
		let state_downed = new MouseState({
			up: (e, next) => {
				this.tmp_persistent = true;
				setTimeout(() => {
					this.tmp_persistent = false;
				}, 100);
				next(state_default);
			},
		});
		return {
			sm: new MouseStateMachine(state_default),
			tmp_persistent: false,
		};
	},
	methods: {
		onClose: function(e) {
			this.$emit('close', e);
		},
	},
	computed: {
		isDisplay : function () {
			return this.display;
		},
		isPersistent: function() {
			return this.persistent || this.tmp_persistent;
		},
		classOverlay: function() {
			let classes = new Array();

			if (!this.isDisplay)
				classes.push('v-overlay--active');

			return classes;
		},
	},
	mounted: function() {
		this.sm.bind(window);
	},
	beforeDestory: function() {
		this.sm.unbind();
	},
};

</script>
<style>
.tc-right-pane.v-dialog {
	border-radius: 0;
	margin: 0;
	min-height: 100%;
	overflow: visible;
	position: absolute;
	right: 0;
}

.tc-right-pane .v-overlay {
	position: absolute;
	width: 100%;
	height: 100%;
}
</style>
